import React from "react";
import "./CodeBlock.scss";

const CodeBlock = ({ language, code, block_id, section_id, report_id }) => (
    <pre
        className={`code-block ${language}`}
        id={block_id || undefined}
        data-block-id={block_id || undefined}
        data-section-id={section_id || undefined}
        data-report-id={report_id || undefined}
    >
        <code>{code}</code>
    </pre>
);

export default CodeBlock;
